<template></template>

<script>
  import { customEventDataType } from '../../plugins/auth'

  export default {
    name: 'sso-callback',
    created () {
      this.$auth.parseHash(this.$route.hash, (err, response) => {
        parent.postMessage(err ? {...err, type: customEventDataType} : {...response, type: customEventDataType}, process.env.SITE_URL)
      })
    }
  }
</script>




// WEBPACK FOOTER //
// src/app/pages/SSO/Callback.vue